import { cn } from '@lib/utils';

interface ChipProps {
  label: string;
  className?: string;
}

const baseChipStyle =
  'rounded size-5 text-sm font-medium flex px-1.5 py-1 justify-center items-center';

function Chip({ label, className }: ChipProps) {
  return <div className={cn(baseChipStyle, className)}>{label}</div>;
}

export default Chip;
